/* DATE UTILS */

export const FORMAT_DATE = 'YYYY-MM-DD'; // AAAA-MM-DD
export const FORMAT_MONTH = 'MMMM'; // Enero, Febrero, Marzo, etc.

export const UNIX_TIMESTAMP_FORMAT = 'X';
